// extracted by mini-css-extract-plugin
export default {"btn":"IconButton_btn__aSI-k"};